import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import api from '../../services/api_adiantamento';
import styles from './styles.module.css';
import fileDownload from 'js-file-download';
import Swal from 'sweetalert2';
import copy from 'copy-to-clipboard';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import moment from 'moment';
import { mask, unMask } from 'remask';
import apidesp from '../../services/api_despesas';
import { ImFolderDownload } from "react-icons/im";


export default function Anomalias() {

    let history = useHistory();

    const [anomalias, setAnomalias] = useState([]);
    const [modalPreenchimentoOpen, setModalPreenchimentoOpen] = useState(false);
    const [modalBancoOpen, setModalBancoOpen] = useState(false);
    const [atualiza, setAtualiza] = useState(true);
    const [modalDownloadOpen, setmodalDownloadOpen] = useState(false);
    const [atualizando, setAtualizando] = useState(false);
    const [anomaliasAfd, setAnomaliasAfd] = useState([]);
    const [dtini, setDtini] = useState('');
    const [dtfim, setDtfim] = useState('');
    const [tipo, setTipo] = useState({
        items: [
            { id: 0, text: "ANOMALIA" },
            { id: 1, text: "BANCO" },
            { id: 3, text: "FALTA JUST." },
            { id: 4, text: "FALTA N. JUST." },
        ],
        selectItem: 0
    });
    const [status, setStatus] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "NÃO APONTADOS" },
            { id: 2, text: "APONTADOS" },
        ],
        selectItem: 1
    });
    const [colaborador, setColaborador] = useState({});
    const [dptoPessoal, setDptoPessoal] = useState(false);

    useEffect(() => {
        apidesp.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    response.data.usuario_perfil.forEach((perfil) => {
                        if (parseInt(perfil.perfil_id) === 9) {
                            setDptoPessoal(true);
                        }
                    })
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        if (atualiza || status) {
            setAtualizando(true);
            api.get(`/anomalias?status=${status.selectItem}`).then(function (response) {
                if (response.data) {
                    setAnomalias(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setAtualiza(false);
                setAtualizando(false);
            });
        }

    }, [atualiza, status]);

    function renderEmpresa(empresa) {
        var emp = ''
        switch (empresa) {
            case 1:
                emp = 'COOPER-RUBI'
                break;
            case 2:
                emp = 'AGRO-RUB'
                break;
            case 3:
                emp = 'CRV-GO'
                break;
            case 4:
                emp = 'PFMO-GO'
                break;
            case 5:
                emp = 'URUAÇU'
                break;
            case 6:
                emp = 'AGRO-URUAÇU'
                break;
            case 7:
                emp = 'CRV-MG'
                break;
            case 8:
                emp = 'PFMO-MG'
                break;
            default:
                break;
        }
        return (emp)

    }

    function converterData(data, hora) {
        return moment(data.substring(3, 5) + '/' + data.substring(0, 2) + '/' + data.substring(6, 10) + ' ' + hora);
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return (maskedValue);
    }

    function handleMaskHoras(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99:9", "99:99"
        ]);
        return (maskedValue);
    }

    function handlePrint() {

        var dataAnomalias = [];

        const objAnomalias = Object.assign([], anomalias);

        var inconsistencias = [];

        objAnomalias.forEach((anomalia) => {
            if (anomalia.checked) {
                anomalia.tipo = parseInt((anomalia.tipo ? anomalia.tipo : 0));
                dataAnomalias.push(anomalia);

                var entrada1 = converterData(anomalia.data, anomalia.apontamento_entrada_1);

                var saida1 = converterData(anomalia.data, anomalia.apontamento_saida_1);

                var entrada2 = converterData(anomalia.data, anomalia.apontamento_entrada_2);

                var saida2 = converterData(anomalia.data, anomalia.apontamento_saida_2);

                if (saida1 < entrada1) {
                    saida1 = saida1.add(1, 'days');
                }

                if (entrada2 < entrada1) {
                    entrada2 = entrada2.add(1, 'days');
                }

                if (saida2 < entrada1) {
                    saida2 = saida2.add(1, 'days');
                }

                var inconsistencia = [];

                if ((saida1 - entrada1) / 1000 / 60 > 360) {
                    inconsistencia.push({
                        motivo: 'JORNADA EXCEDE 06 HORAS CONSECUTIVAS',
                        entrada1: anomalia.apontamento_entrada_1,
                        saida1: anomalia.apontamento_saida_1,
                    })
                }

                if ((saida2 - entrada2) / 1000 / 60 > 360) {
                    inconsistencia.push({
                        motivo: 'JORNADA EXCEDE 06 HORAS CONSECUTIVAS',
                        entrada2: anomalia.apontamento_entrada_2,
                        saida2: anomalia.apontamento_saida_2,
                    })
                }

                if ((entrada2 - saida1) / 1000 / 60 < 30) {
                    inconsistencia.push({
                        motivo: 'HORARIO INTRAJORNADA INFERIOR A 30 MINUTOS',
                        entrada2: anomalia.apontamento_entrada_2,
                        saida1: anomalia.apontamento_saida_1,
                    })
                }

                if (((saida1 - entrada1) + (saida2 - entrada2)) / 1000 / 60 > 600) {
                    inconsistencia.push({
                        motivo: 'A QUANTIDADE DE HORAS TOTAIS ULTRAPASSAM 10 HORAS',
                        entrada1: anomalia.apontamento_entrada_1,
                        saida1: anomalia.apontamento_saida_1,
                        entrada2: anomalia.apontamento_entrada_2,
                        saida2: anomalia.apontamento_saida_2,
                    })
                }

                if (inconsistencia.length > 0) {
                    inconsistencias.push(
                        {
                            colaborador: anomalia.funcionario,
                            data: anomalia.data,
                            inconsistencias: inconsistencia
                        }
                    );
                }
            }
        })

        if (inconsistencias.length > 0) {

            var html = '';

            inconsistencias.forEach((inconsistencia) => {
                html = html + `<b style="font-size:0.8rem;">${inconsistencia.colaborador} DATA: ${inconsistencia.data}</b><br/>`;
                inconsistencia.inconsistencias.forEach((inc) => {
                    html = html + `<b style="font-size:0.7rem;">MOTIVO: ${inc.motivo} | 
                ${inc.entrada1 || ''} ${inc.saida1 || ''}${inc.entrada1 || inc.saida1 ? ' - ' : ''}${inc.entrada2 || ''} ${inc.saida2 || ''}<br/></b>`
                });
            });

            var htmltitle = `<b style="font-size:0.8rem;">ATENÇÃO, AS SEGUINTES BATIDAS POSSUEM INCONSISTENCIAS</b>`
            Swal.fire({
                title: htmltitle,
                html: html,
                width: 1500,
                confirmButtonText: 'OK'
            });
            return;
        }

        const arrgrup = [];
        const matriculas = [];


        dataAnomalias.forEach((anomalia) => {
            var i = '';
            if (anomalia.tipo === 1) {
                i = anomalia.matricula.toString() + anomalia.tipo.toString();
            } else {
                i = anomalia.id_empresa;
            }
            arrgrup[parseInt(i)] = {
                matricula: anomalia.matricula,
                id_empresa: anomalia.id_empresa,
                tipo: anomalia.tipo
            };
        });


        arrgrup.forEach((a) => {
            matriculas.push(a);
        })


        var body = {
            anomalias: dataAnomalias,
            matriculas: matriculas,
        }


        api.post(`/anomalias`, body, {
            responseType: 'blob',
        }).then(function (response) {
            if (response.data) {

                if (response.data.erro) {
                    alert(response.data.erro)
                } else {

                    fileDownload(response.data, 'ANOMALIA.pdf');

                }

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
            setAtualiza(true);
        });
    }

    function handleClickAnomalia(anomalia) {
        // setModalPreenchimentoOpen(true);
    }

    function handleChangeAnomalia(anomalia, checked) {
        var objAnomalias = Object.assign([], anomalias);
        var checkedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));

        if (checked) {
            checkedAnomalia.checked = true;
        } else {
            checkedAnomalia.checked = false;
        }
        setAnomalias(objAnomalias);
    }

    function handleChangeAnomaliaAfd(anomalia, checked) {
        var objAnomalias = Object.assign([], anomaliasAfd);
        var checkedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));

        if (checked) {
            checkedAnomalia.checked = true;
        } else {
            checkedAnomalia.checked = false;
        }
        setAnomaliasAfd(objAnomalias);
    }

    function handlePrintAnomalia(anomalia) {

        api.post(`/anomalias/individual`, { anomalia: anomalia }, {
            responseType: 'blob',
        }).then(function (response) {
            if (response.data) {

                if (response.data.erro) {
                    alert(response.data.erro)
                } else {

                    fileDownload(response.data, 'ANOMALIA.pdf');

                }

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderCheckAnomalia(anomalia) {
        if (anomalia.status_anomalia === 0) {
            if (anomalia.checked) {
                return (
                    <td><input type="checkbox" checked onChange={() => handleChangeAnomalia(anomalia, false)} /></td>
                )
            } else {
                return (
                    <td><input type="checkbox" onChange={() => handleChangeAnomalia(anomalia, true)} /></td>
                )
            }
        } else {
            return (
                <td>
                    <div className={styles.downlaodAnomalia}>
                        <ImFolderDownload color='green' onClick={() => handlePrintAnomalia(anomalia)} />
                    </div>
                </td>
            )
        }
    }

    function renderRow() {

        return (
            anomalias.map((anomalia) => {
                return (
                    <tr>
                        {/* <td><BsCloudDownloadFill color='green' size='30' className={styles.btndownload} onClick={() => handleClickAnomalia(anomalia)} /></td> */}
                        {renderCheckAnomalia(anomalia)}
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{renderEmpresa(anomalia.id_empresa)}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.data}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.matricula}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.funcionario}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.marcacoes_entrada_1}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.marcacoes_saida_1}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.marcacoes_entrada_2}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.marcacoes_saida_2}</td>
                    </tr>
                )
            })
        )
    }

    function fecharModalPreenchimento() {
        setModalPreenchimentoOpen(false);
    }

    function handleChangeEntrada1(anomalia, valor) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.apontamento_entrada_1 = valor;
        setAnomalias(objAnomalias);
    }

    function handleChangeEntrada2(anomalia, valor) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.apontamento_entrada_2 = valor;
        setAnomalias(objAnomalias);
    }


    function handleChangeSaida1(anomalia, valor) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.apontamento_saida_1 = valor;
        setAnomalias(objAnomalias);
    }


    function handleChangeSaida2(anomalia, valor) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.apontamento_saida_2 = valor;
        setAnomalias(objAnomalias);
    }

    function handleChangeMotivo(anomalia, valor) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.motivo = valor;
        setAnomalias(objAnomalias);
    }

    function handleCopy(e, valor) {
        // alert('copiou esse'+valor);
        // e.clipboardData.setData('text/plain',valor);
        copy(valor);

        Swal.fire({
            title: 'APONTAMENTO COPIADO COM SUCESSO',
            timer: 500,
            showConfirmButton: false,
        }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
                console.log('I was closed by the timer')
            }
        })
    }


    function renderAnomalias() {
        return (
            anomalias.map((anomalia) => {
                if (anomalia.checked) {
                    return (
                        <>
                            <br />
                            <hr />
                            <div className={styles.headerpessoa}>
                                <div>
                                    {anomalia.funcionario} - {anomalia.data}
                                </div>
                                <div className={styles.divtabela}>
                                    <div>JORNADA</div>
                                    <div className={styles.marcacoesjornada}>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.jornada_entrada_1)}>{anomalia.jornada_entrada_1}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.jornada_saida_1)}>{anomalia.jornada_saida_1}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.jornada_entrada_2)}>{anomalia.jornada_entrada_2}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.jornada_saida_2)}>{anomalia.jornada_saida_2}</div>
                                    </div>
                                </div>
                            </div>
                            <div>

                            </div>
                            <hr />
                            <div className={styles.headeranomalias}>
                                <div>
                                    MARCAÇÕES
                                </div>
                                <div>
                                    APONTAMENTO
                                </div>
                                <div>
                                </div>
                            </div>
                            <div className={styles.headeranomalias}>
                                <div className={styles.marcacoes}>
                                    <div className={styles.marcacoesjornada}>
                                        <div className={styles.borda}>ENTRADA</div>
                                        <div className={styles.borda}>SAIDA</div>
                                        <div className={styles.borda}>ENTRADA</div>
                                        <div className={styles.borda}>SAIDA</div>
                                    </div>
                                    <div className={styles.marcacoesjornada}>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.marcacoes_entrada_1)}>{(anomalia.marcacoes_entrada_1 ? anomalia.marcacoes_entrada_1 : '-')}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.marcacoes_saida_1)}>{(anomalia.marcacoes_saida_1 ? anomalia.marcacoes_saida_1 : '-')}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.marcacoes_entrada_2)}>{(anomalia.marcacoes_entrada_2 ? anomalia.marcacoes_entrada_2 : '-')}</div>
                                        <div className={styles.borda} onClick={(e) => handleCopy(e, anomalia.marcacoes_saida_2)}>{(anomalia.marcacoes_saida_2 ? anomalia.marcacoes_saida_2 : '-')}</div>
                                    </div>
                                </div>
                                <div className={styles.marcacao}>
                                    <div>
                                        <div>
                                            ENTRADA
                                        </div>
                                        <div>
                                            <input type="text" value={anomalia.apontamento_entrada_1} onChange={(e) => handleChangeEntrada1(anomalia, handleMaskHoras(e.target.value))} />
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            SAIDA
                                        </div>
                                        <div>
                                            <input type="text" value={anomalia.apontamento_saida_1} onChange={(e) => handleChangeSaida1(anomalia, handleMaskHoras(e.target.value))} />
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            ENTRADA
                                        </div>
                                        <div>
                                            <input type="text" value={anomalia.apontamento_entrada_2} onChange={(e) => handleChangeEntrada2(anomalia, handleMaskHoras(e.target.value))} />
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            SAIDA
                                        </div>
                                        <div>
                                            <input type="text" value={anomalia.apontamento_saida_2} onChange={(e) => handleChangeSaida2(anomalia, handleMaskHoras(e.target.value))} />
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.motivo}>
                                    <div>
                                        MOTIVO
                                    </div>
                                    <input type="text" value={anomalia.motivo} onChange={(e) => handleChangeMotivo(anomalia, e.target.value)} />
                                </div>
                                <div>
                                    <div>
                                        DESTINO
                                    </div>
                                    <select
                                        className="col-md-12 combobox  edit form-control column-filtro"
                                        id="tipo"
                                        value={(anomalia.tipo ? anomalia.tipo : 0)}
                                        onChange={(e) => handleSetTipo(e.target.value, anomalia)}
                                    // ref={tipoRef}
                                    // onKeyDown={(e) => handledown(e, etapaRef)}
                                    >
                                        {tipo.items.map((item, index) => (
                                            <option key={index} value={item.id}>{item.text}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </>
                    )
                }
            })
        )
    }

    function handleSetTipo(value, anomalia) {
        var objAnomalias = Object.assign([], anomalias);
        var selectedAnomalia = objAnomalias.find(a => (a.matricula === anomalia.matricula && a.data === anomalia.data));
        selectedAnomalia.tipo = parseInt(value);
        setAnomalias(objAnomalias);
    }

    function handleSelectValue(value, obj) {
        const objselected = Object.assign([], obj);
        objselected.selectItem = value;
        return objselected;
    }


    function renderModalPreenchimento() {
        return (
            <div className={(modalPreenchimentoOpen ? styles.modaldespesas : styles.modalfechado)}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalPreenchimento()}><b>x</b></span>
                <div>
                    <h3>PREENCHER ANOMALIA</h3>
                </div>
                <div className={styles.modalapontamento}>
                    <div className={styles.bodyanomalias}>
                        {renderAnomalias()}
                    </div>
                    <hr />
                    <input type="button" onClick={() => handlePrint()} value="IMPRIMIR" />
                </div>
            </div>
        )
    }

    function handlePreencher() {
        setModalPreenchimentoOpen(true);
    }

    function renderBtnImprimir() {
        var canprint = false;
        anomalias.forEach((anomalia) => {
            if (anomalia.checked) {
                canprint = true;
            }
        })
        if (canprint) {
            return (
                <input type="button" value="PREENCHER BATIDAS" className='btn btn-primary' onClick={() => handlePreencher()} />
            )
        } else {
            <></>
        }
    }

    function handleFecharModalBanco() {
        setModalBancoOpen(false);
    }

    function handledown(e) {

        if (e.key === "Enter") {

            setColaborador({});

            if (e.target.value !== '') {
                api.get(`/anomalias/colaborador/${e.target.value}`)
                    .then(function (response) {
                        if (response.data && response.data !== 'OK') {
                            setColaborador(response.data);
                        } else {
                            Swal.fire('COLABORADOR NÃO ENCONTRADO')
                        }
                    }).catch(function (error) {
                        // handle error
                        alert(error);
                        console.log(error);
                    }).then(function () {
                        // always executed
                    });
            }
        }
    }

    function handleDeleteApontamento(index) {
        var objcolaborador = Object.assign({}, colaborador);

        objcolaborador.apontamentos.splice(index, 1)
        setColaborador(objcolaborador);
    }

    function handleChangeData(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].data = value;
        setColaborador(objColaborador);
    }

    function handleChangeApontamentoEntrada1(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].apontamento_entrada_1 = value;
        setColaborador(objColaborador);
    }

    function handleChangeApontamentoSaida1(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].apontamento_saida_1 = value;
        setColaborador(objColaborador);
    }

    function handleChangeApontamentoEntrada2(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].apontamento_entrada_2 = value;
        setColaborador(objColaborador);
    }

    function handleChangeApontamentoSaida2(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].apontamento_saida_2 = value;
        setColaborador(objColaborador);
    }

    function handleChangeApontamentoMotivo(value, index) {
        const objColaborador = Object.assign({}, colaborador);
        colaborador.apontamentos[index].motivo = value;
        setColaborador(objColaborador);
    }

    function renderApontamentos() {
        if (colaborador.apontamentos && colaborador.apontamentos.length > 0) {
            return (
                colaborador.apontamentos.map((apontamento, index) => {
                    return (
                        <div className={styles.bancodehoras}>
                            <div className={styles.marcacaobanco}>
                                <div>
                                    <div>
                                        DATA
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.data} onChange={(e) => handleChangeData(handleMaskData(e.target.value), index)} />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        ENTRADA
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.apontamento_entrada_1} onChange={(e) => handleChangeApontamentoEntrada1(handleMaskHoras(e.target.value), index)} />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        SAIDA
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.apontamento_saida_1} onChange={(e) => handleChangeApontamentoSaida1(handleMaskHoras(e.target.value), index)} />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        ENTRADA
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.apontamento_entrada_2} onChange={(e) => handleChangeApontamentoEntrada2(handleMaskHoras(e.target.value), index)} />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        SAIDA
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.apontamento_saida_2} onChange={(e) => handleChangeApontamentoSaida2(handleMaskHoras(e.target.value), index)} />
                                    </div>
                                </div>

                            </div>
                            <div className={styles.motivobanco}>
                                <div >
                                    <div>
                                        MOTIVO
                                    </div>
                                    <div>
                                        <input type="text" value={apontamento.motivo} onChange={(e) => handleChangeApontamentoMotivo(e.target.value, index)} />
                                    </div>
                                </div>
                                <div >
                                    <div><br></br></div>
                                    <FaMinusCircle className={styles.btnapagarlcto} color='red' size="20" onClick={() => handleDeleteApontamento(index)} />
                                </div>
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    function handleAddApontamento() {

        var objcolaborador = Object.assign({}, colaborador);
        if (!objcolaborador.apontamentos) {
            objcolaborador.apontamentos = [{
                apontamento_entrada_1: '',
                apontamento_entrada_2: '',
                apontamento_saida_1: '',
                apontamento_saida_2: '',
                data: '',
                motivo: '',
            }]
        } else {
            objcolaborador.apontamentos.push({
                apontamento_entrada_1: '',
                apontamento_entrada_2: '',
                apontamento_saida_1: '',
                apontamento_saida_2: '',
                data: '',
                motivo: '',
            })
        }

        setColaborador(objcolaborador);
    }

    function handlePrintBanco() {
        api.post(`/anomalias/banco`, colaborador, {
            responseType: 'blob',
        }).then(function (response) {
            if (response.data) {

                if (response.data.erro) {
                    alert(response.data.erro)
                } else {

                    fileDownload(response.data, 'BANCO DE HORAS.pdf');

                }

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderPrintBanco() {
        if(colaborador.apontamentos && colaborador.apontamentos.length > 0) {
            return (
                <input className='btn btn-sm btn-primary' type="button" onClick={() => handlePrintBanco()} value="IMPRIMIR" />
            )
        }
    }

    function renderBatidasBanco() {
        if (colaborador && colaborador.matricula) {
            return (
                <div>
                    {renderApontamentos()}
                    <div >
                        <FaPlusCircle className={styles.btnnovoapontamento} color="green" size="45" onClick={() => handleAddApontamento()} />
                    </div>
                    {renderPrintBanco()}
                </div>
            )
        }
    }

    function renderModalBanco() {
        return (
            <div className={(modalBancoOpen ? styles.modaldespesas : styles.modalfechado)}>
                <span className="fechar-modal-previsoes" onClick={() => handleFecharModalBanco()}><b>x</b></span>
                <div>
                    <h3>SOLICITAÇÃO DE HORAS EXTRAS</h3>
                </div>
                <div className={styles.modalapontamento}>
                    <div className={styles.nomemat}>
                        <div>
                            <div>
                                MATRICULA
                            </div>
                            <input type="text" onKeyDown={(e) => handledown(e)} />
                        </div>
                        <div>
                            <div>
                                <b>NOME: {colaborador.funcionario}</b>
                            </div>
                            <div><b>DEPARTAMENTO: {colaborador.depto} - {colaborador.setor} </b></div>
                        </div>
                    </div>
                    {renderBatidasBanco()}
                </div>
            </div>
        )
    }

    function handleBancoDeHoras() {
        setModalBancoOpen(true);
    }

    function handleExport() {

        var selectedAnomalias = [];

        anomaliasAfd.forEach((anomalia) => {
            if (anomalia.checked) {
                selectedAnomalias.push(anomalia.id)
            }
        })

        api.post(`/anomalias/export`, { anomalias: selectedAnomalias }, {
            responseType: 'blob',
        })
            .then(function (response) {
                if (response.data && response.data !== 'OK') {
                    fileDownload(response.data, 'AFD.txt');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
    }

    function handleOpemModalDownload() {
        setmodalDownloadOpen(true);
    }

    function renderDownloads() {
        if (dptoPessoal) {
            return (
                <input type="button" value="GERAR AFD" onClick={() => handleOpemModalDownload()} />
            )
        }

    }

    function handleFecharModalDownload() {
        setmodalDownloadOpen(false);
    }

    function renderCheckAnomaliaAfd(anomalia) {
        if (anomalia.checked) {
            return (
                <td><input type="checkbox" checked onChange={() => handleChangeAnomaliaAfd(anomalia, false)} /></td>
            )
        } else {
            return (
                <td><input type="checkbox" onChange={() => handleChangeAnomaliaAfd(anomalia, true)} /></td>
            )
        }
    }

    function renderRowAfd() {
        return (
            anomaliasAfd.map((anomalia) => {
                return (
                    <tr>

                        {renderCheckAnomaliaAfd(anomalia)}
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{renderEmpresa(anomalia.empresa_id)}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.data}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.matricula}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.nome}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.entrada1}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.saida1}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.entrada2}</td>
                        <td className={styles.itemanomalia} onClick={() => handleClickAnomalia(anomalia)}>{anomalia.saida2}</td>
                    </tr>
                )
            })
        )

    }

    function handleBuscaAfd() {
        api.get(`/anomalias/apontamentos?dtini=${dtini}&dtfim=${dtfim}`)
            .then(function (response) {
                if (response.data && response.data !== 'OK') {

                    setAnomaliasAfd(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
    }

    function renderModalDownload() {
        return (
            <div className={(modalDownloadOpen ? styles.modaldespesas : styles.modalfechado)}>
                <span className="fechar-modal-previsoes" onClick={() => handleFecharModalDownload()}><b>x</b></span>
                <div>
                    <h3>DADOS PARA GERAÇÃO DE AFD</h3>
                </div>
                <div className={styles.gridafd}>
                    <div>
                        <label>DATA INICIAL</label>
                        <div><input type="text" value={dtini} onChange={(e) => setDtini(handleMaskData(e.target.value))} /></div>
                    </div>
                    <div>
                        <label>DATA FINAL</label>
                        <div><input type="text" value={dtfim} onChange={(e) => setDtfim(handleMaskData(e.target.value))} /> </div>
                    </div>
                </div>
                <input type="button" value="CONSULTAR" onClick={() => handleBuscaAfd()} />
                <table className="table table-sm">
                    <thead>
                        <th></th>
                        <th>EMPRESA</th>
                        <th>DATA</th>
                        <th>MATRÍCULA</th>
                        <th>COLABORADOR</th>
                        <th>ENTRADA</th>
                        <th>SAIDA</th>
                        <th>ENTRADA</th>
                        <th>SAIDA</th>
                    </thead>
                    <tbody>
                        {renderRowAfd()}
                    </tbody>
                </table>
                <input type="button" value="CONSULTAR" onClick={() => handleExport()} />
            </div>
        )
    }

    function renderDados() {
        if (atualizando) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                <table className="table table-sm">

                    <thead>
                        <th></th>
                        <th>EMPRESA</th>
                        <th>DATA</th>
                        <th>MATRÍCULA</th>
                        <th>COLABORADOR</th>
                        <th>ENTRADA</th>
                        <th>SAIDA</th>
                        <th>ENTRADA</th>
                        <th>SAIDA</th>
                    </thead>
                    <tbody>
                        {renderRow()}
                    </tbody>
                </table>
            )
        }
    }

    return (
        <>
            {renderModalDownload()}
            {renderModalPreenchimento()}
            {renderModalBanco()}
            <div className="container-lg">
                <Header title="ANOMALIAS DE PONTO" />
                <hr />
                {renderDownloads()}
                <hr />
                <div className={styles.bodycontent}>

                    <select
                        className="col-md-12 combobox  edit form-control column-filtro"
                        id="tipo"
                        value={status.selectItem}
                        onChange={(e) => setStatus(handleSelectValue(e.target.value, status))}
                    >
                        {status.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                    {renderDados()}
                </div>
                {renderBtnImprimir()}
                <input type="button" value="BANCO DE HORAS" className='btn btn-success' onClick={() => handleBancoDeHoras()} />
            </div>
        </>
    )
}